<template>
  <StepModel
    :ui="uiBaseStep"
    :name="STEP_NAMES.uploadIdentityDigital"
    ui-title=""
    ui-subtitle=""
    ui-error-message="Something went wrong when we tried to read your ID.
    Please upload again or enter your information manually."
    ui-button-text="Submit"
     ui-secondary-button="or do it manually"
    :ui-secondary-action="goToNextStepWithoutValidate"
  >
  <!-- <FieldsetModel :ui="uiBaseFieldset" name="fieldSetStep7" ui-title="" >
        
      </FieldsetModel> -->
   <FieldsetModel :ui="uiBaseFieldset" name="fieldSetOCR" >
      <p style=" color: #6e3dea;
  font-weight: 500;
  font-size: 30px">Let's get to know you</p>
   </FieldsetModel>
    <FieldsetModel :ui="uiBaseFieldset" :name="FIELDSET_NAMES.upload" ui-columns="2" 
    ui-title="Upload a picture of your Emirates ID (Front & Back)">
      <UiWrapper
        :name="FIELD_NAMES.emiratesFrontCard"
        label="Upload the front of your ID"
        :max-file-size="15360"
      >
        <UploadWrapper
          :upload-service="readOCRAndChangeFields('front')"
          accept="image/jpeg, image/png"
          :changeable="true"
          id-side="front"
        />
      </UiWrapper>
      <UiWrapper
        :name="FIELD_NAMES.emiratesBackCard"
        label="Upload the back of your ID"
        :max-file-size="15360"
      >
        <UploadWrapper
          :upload-service="readOCRAndChangeFields('back')"
          accept="image/jpeg, image/png"
          :changeable="true"
          id-side="back"
        />
      </UiWrapper>
    </FieldsetModel>
  </StepModel>
</template>

<script>
import FormComponentMixin from "@/lib/mixins/form-component-mixin";
import uploadService from "@/forms/api/services/upload";
//import getGoogleTagManager from "@/forms/helpers/google-tag-manager";
// Components
import UploadWrapper from "@/forms/components/ui-dunia/upload-wrapper";
import UiWrapper from "@/forms/components/base/ui-wrapper";
import StepModel from "@/lib/components/models/step";
import FieldsetModel from "@/lib/components/models/fieldset";
import * as conditions from "@/forms/conditions";
export default {
  components: {
    UploadWrapper,
    StepModel,
    UiWrapper,
    FieldsetModel
  },

  mixins: [FormComponentMixin],
  data:()=>({
 identityInfo:"Identity verification",
  }),
  prop:{
    stepTitle:{
      type:String
    },
    subTitle:{
      type:String
    },
  },
  mounted() {
    //getGoogleTagManager();
    var gtagID = process.env.VUE_APP_GA_MEASUREMENT_ID;
    if (gtagID) {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", `${gtagID}`);
    }
  },
  methods: {
    readOCRAndChangeFields: uploadService.readOCRAndChangeFields
  }
};
</script>
<style scoped>
.identityTitle {
  
  color: #6e3dea;
  font-weight: 200;
  font-size: 30px;
}
/* Progess Bar with steps */
.stepper-wrapper {
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.stepper-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 12px;
  }
}

.stepper-item::before {
  position: absolute;
  content: "";
  border-bottom: 3px solid #ccc;
  width: 100%;
  top: 15px;
  left: -50%;
  z-index: 2;
}

.stepper-item::after {
  position: absolute;
  content: "";
  border-bottom: 3px solid #ccc;
  width: 100%;
  top: 15px;
  left: 50%;
  z-index: 2;
}

.stepper-item .step-counter {
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #ccc;
  margin-bottom: 6px;
}

.stepper-item.active {
  font-weight: bold;
 

}
.step-counter.active{
  background-color: #6e3dea;
}

.stepper-item.completed .step-counter {
  background-color: #6e3dea;
}

.stepper-item.completed::after {
  position: absolute;
  content: "";
  /* border-bottom: 2px solid #6e3dea; */
  width: 100%;
  top: 15px;
  left: 50%;
  z-index: 3;
}

.stepper-item:first-child::before {
  content: none;
}
.stepper-item:last-child::after {
  content: none;
}
</style>
